<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">Shift tags</h5>
        <div class="edit-icons" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column ">
        <div class="header d-flex flex-wrap gap-2">
            <div class="d-flex align-items-center me-auto flex-wrap me-2 gap-2">
                <div class="user-profile name mt-3">
                    <div class="profile-img me-2" [appBackgroundImg]="dialogData?.profile_picture"> </div>

                    <div class="">
                        <div class="main-head p-name">{{timeSheetInfo?.first_name}}
                            {{timeSheetInfo?.last_name}}</div>
                        <div class="sub-head">{{timeSheetInfo?.email}}</div>
                    </div>
                </div>
                <div class="d-flex align-items-center">Pay period:</div>
                <mat-form-field class="c-d-r" appearance="fill">
                    <mat-date-range-input [rangePicker]="picker" [formGroup]="range">
                        <input matStartDate placeholder="Start date" (click)="picker.open()" formControlName="start" />
                        <input matEndDate placeholder="End date" (click)="picker.open()" formControlName="end" />
                    </mat-date-range-input>
                    <mat-date-range-picker #picker (closed)="onCloseCal()"></mat-date-range-picker>
                </mat-form-field>
                <mat-select [value]="'all-days'" class="form-control s-1 cal-view me-3">
                    <mat-option value="all-days">All days</mat-option>
                </mat-select>
            </div>
            <div class="d-flex align-items-center flex-wrap gap-2 me-2">
                <div class="btn btn-outline-primary d-flex align-items-center" (click)="onOpenConflicts()"> Conflicts
                </div>
                <!-- <mat-select [value]="'add'" class="form-control s-1 cal-view me-3">
                    <mat-option value="add">Add</mat-option>
                    <mat-option value="edit">Add Shift</mat-option>
                    <mat-option value="2013">Add Time off</mat-option>
                </mat-select> -->
                <mat-select [value]="'export'" (valueChange)="onValueChange($event)" class="form-control s-1 cal-view ">
                    <mat-option value="export">Export</mat-option>
                    <mat-option value="payroll">Payroll Totals</mat-option>
                    <mat-option value="timesheet">Timesheets</mat-option>
                    <mat-option value="shift_report">Shift Report</mat-option>
                </mat-select>
                <!-- <div class="btn-outline-primary btn d-flex align-items-center"> Approve </div> -->
            </div>
        </div>
        <div class="header d-flex flex-wrap gap-2 b-top b-bottom">
            <div class="d-flex me-auto align-items-center flex-wrap me-2 " style="gap: 10px 0px;">
                <div class="s-div blue-badge">
                    <div class="time">{{timeSheetInfo?.reg_h}}</div>
                    <div class="title">Regular</div>
                </div>
                <span class="blue-badge-c b-r-50 me-2 ms-2">+</span>
                <div class="s-div active">
                    <div class="time">00:00</div>
                    <div class="title">1.5x overtime</div>
                </div>
                <span class="active-c b-r-50 me-2 ms-2">+</span>
                <div class="s-div pending">
                    <div class="time">00:00</div>
                    <div class="title">Paid time off</div>
                </div>
                <span class="pending-c b-r-50 me-2 ms-2">=</span>
                <div class="s-div b-r blue-badge me-3">
                    <div class="time">00:00</div>
                    <div class="title">Total paid hours</div>
                </div>
                <div class="s-div coffee-badge me-1">
                    <div class="time">{{timeSheetInfo?.break}}</div>
                    <div class="title">paid breaks</div>
                </div>
            </div>
            <div class="d-flex flex-wrap gap-3 me-2">
                <div class="s-div">
                    <div class="time">€{{timeSheetInfo?.wages.toFixed(2)}}</div>
                    <div class="title">Pay per dates</div>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <div class="new-table-container new-table">

                <div class="fixed-head smart-table">
                    <div class="head hs"> Date</div>
                    <div class="head hs cat">Category</div>
                    <div class="head hs comp">Company</div>
                    <div class="head hs st-ti">Address</div>
                    <div class="head hs st-ti">Start Time - End Time</div>
                    <div class="head hs st-ti">Break Start Time - End Time</div>
                    <div class="head hs st-ti">Shift Start Time - End Time</div>
                    <div class="head hs t-ti">Total hours</div>
                    <div class="head hs t-ti">Total working hours</div>
                    <div class="head hs t-ti">Overtime hours</div>
                    <div class="head hs t-ti">Daily Total</div>
                    <div class="head hs t-ti">Weekly total</div>
                    <div class="head hs t-ti">Total Regular</div>
                    <div class="head hs ms-ti st-ti ps-40">Manager Signature</div>
                    <div class="head hs t-ti m-w-190">Employee Notes</div>
                    <div class="head hs t-ti m-w-190">Clock In Image</div>
                    <div class="head hs t-ti m-w-190">Clock Out Image</div>
                    <div class="head hs t-ti m-w-190">Employee Signature</div>
                    <div class="head hs t-ti m-w-190">Accept/Reject</div>
                    <div class="head hs t-ti m-w-190">Action</div>
                </div>
                <div *ngFor="let val of timeSheetArr" class="">
                    <div class="week-h">{{val.ed_dt | dates}} - {{val.st_dt | dates}}</div>
                    <!-- //w-max-c -->
                    <div class="w-100 d-flex align-items-center">
                        <div class="w-100">
                            <div class="sub hs d-flex align-items-center pe-0" *ngFor="let it of val.arr;let i = index">
                                <div class="d-flex align-items-center position-relative">
                                    <div class="purple-dot purple-dot-1 "
                                        *ngIf="it.wo_data.cu_name && it.wo_data.cu_pic">
                                        <div class="purple-model">
                                            {{it.wo_data.cu_name}} {{it.wo_data.cu_pic}}
                                        </div>
                                    </div>
                                    {{it.date | dates}}
                                </div>

                                <div class=" d-flex align-items-center">
                                    <div class="d-flex flex-column">

                                        <div *ngFor="let v of it.wo_data">
                                            <div *ngIf="v.id" class=" d-flex align-items-center">
                                                <div class="t-i cat">
                                                    <div class="small-text">{{v.j_c}} </div>
                                                    <div class="small-text">{{v.j_sc}}</div>
                                                </div>
                                                <div class="t-i comp">
                                                    <div class="d-flex align-items-center gap-2">
                                                        <div class="company-logo">
                                                            <img *ngIf="v.company_logo" [src]="checkUrl(v.company_logo)"
                                                                alt="">
                                                            <img *ngIf="!v.company_logo"
                                                                src="assets/images/logo/logo.svg" alt="">
                                                        </div>
                                                        <div class="small-text hide-lines-2">{{v.company_name}}</div>
                                                    </div>

                                                </div>
                                                <div
                                                    class="t-i st-ti  st-add d-flex align-items-center gap-1 position-relative ">
                                                    <div class="hide-lines-2">
                                                        {{v.add}}
                                                    </div>
                                                </div>
                                                <div
                                                    class="t-i st-ti d-flex align-items-center gap-1 position-relative ">

                                                    <div class="yellow-dot yellow-dot-1 "
                                                        *ngIf="v.la_upd || v.updu_pic || v.updu_name">
                                                        <div class="yellow-model">
                                                            {{v.updu_name}}
                                                        </div>
                                                    </div>
                                                    <div class="position-relative ih-1 d-flex align-items-center"
                                                        *ngIf="v.id">
                                                        <input class="form-control" type="text" [(ngModel)]="v.st_ti">
                                                        <a target="blank" *ngIf="v.lat"
                                                            [href]="googleMapLink + v.lat + ',' + v.long">
                                                            <i class="material-icons "
                                                                [ngClass]="v.in_icon == 1 ? 'color-red' : 'color-green' ">location_on</i>
                                                        </a>
                                                        <div class="add1">
                                                            {{v.cl_in_add}}
                                                        </div>
                                                    </div>
                                                    <div *ngIf="v.id">-</div>
                                                    <div class="position-relative ih-2 d-flex align-items-center"
                                                        *ngIf="v.id">
                                                        <input class="form-control" type="text" [(ngModel)]="v.ed_ti">
                                                        <a target="blank" *ngIf="v.lat"
                                                            [href]="googleMapLink + v.c_lat + ',' + v.c_long">
                                                            <i class="material-icons "
                                                                [ngClass]="v.out_icon == 1 ? 'color-red' : 'color-green' ">location_on</i>
                                                        </a>
                                                        <div class="add2">
                                                            {{v.cl_out_add}}
                                                        </div>
                                                    </div>
                                                    <button class="btn btn-primary" *ngIf="v.add"
                                                        (click)="onChangeTime(v.st_ti, v.ed_ti, v.date,v.em_i,v.clock_id,v.id,v.br_tii, v.br_tio,false)">Save</button>
                                                </div>
                                                <div
                                                    class="t-i st-ti d-flex align-items-center gap-1 position-relative ">
                                                    <div class="position-relative ih-1" *ngIf="v.add">
                                                        <input class="form-control p-2" type="text"
                                                            [(ngModel)]="v.br_tii">
                                                        <div class="add1">
                                                            {{v.add}}
                                                        </div>
                                                    </div>
                                                    <div *ngIf="v.add">-</div>
                                                    <div class="position-relative ih-2" *ngIf="v.add">
                                                        <input class="form-control" type="text" [(ngModel)]="v.br_tio">
                                                        <div class="add2">
                                                            {{v.add}}
                                                        </div>
                                                    </div>
                                                    <button class="btn btn-primary" *ngIf="v.add"
                                                        (click)="onChangeTime(v.st_ti, v.ed_ti, v.date,v.em_i,v.clock_id,v.id,v.br_tii, v.br_tio,true)">Save</button>
                                                </div>

                                                <div
                                                    class="t-i st-ti d-flex align-items-center gap-1 position-relative ">
                                                    {{v.c_st_ti}}
                                                    <div *ngIf="v.add">-</div>
                                                    {{v.c_ed_ti}}
                                                </div>

                                                <div class="t-i t-ti" *ngIf="v.id">{{it.tot_hour}}</div>
                                                <div class="t-i t-ti" *ngIf="v.id">{{v.wo_ti}}</div>
                                                <div class="t-i t-ti" *ngIf="v.id">{{v.ov_ti_h}}</div>
                                                <div class="t-i t-ti " [ngClass]="{'red-frame': it.dta == 1}"
                                                    *ngIf="it.tot_hour!='00:00:00' && v.id">{{it.tot_w_hour}}
                                                </div>
                                                <div class="t-i t-ti" *ngIf="!v.id"></div>
                                                <div class="t-i t-ti" *ngIf="!v.id"></div>
                                                <div class="t-i t-ti" *ngIf="!v.id"></div>
                                                <div class="t-i t-ti" *ngIf="!v.id"></div>

                                                <div class="t-ti" *ngIf="val.week_tot_time!='00:00:00' && v.id">
                                                    {{val.week_tot_wo_time}}</div>
                                                <div class="t-ti" *ngIf="val.week_tot_time!='00:00:00' && v.id">
                                                    {{val.week_tot_time}}</div>
                                                <div class="t-ti" *ngIf="!v.id"></div>
                                                <div class="t-ti" *ngIf="!v.id"></div>

                                                <div class="st-ti ms-ti ps-40" *ngIf="!v.ma_sign && v.id">
                                                    <div class="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                                        (click)="onManagerSign(v)">Click to sign</div>
                                                </div>

                                                <div class="st-ti ms-ti ps-40" *ngIf="v.ma_sign">
                                                    <div class="m-img">
                                                        <img (click)="onManagerSign(v)" [src]="checkUrl(v.ma_sign)"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                </div>

                                                <div class="st-ti ms-ti ps-40" *ngIf="!v.id"></div>
                                                <div class="ms-ti" *ngIf="v.id">
                                                    <div class="hide-lines-2">{{v.emp_notes}}</div>
                                                </div>
                                                <div class="ms-ti" *ngIf="v.id">
                                                    <div class="c-img" *ngIf="v.cl_in_img">
                                                        <img [src]="checkUrl(v.cl_in_img)" class="img-fluid" alt="">
                                                    </div>
                                                </div>
                                                <div class="ms-ti" *ngIf="v.id">
                                                    <div class="c-img" *ngIf="v.cl_out_img">
                                                        <img [src]="checkUrl(v.cl_out_img)" class="img-fluid" alt="gggg"
                                                            (error)="onImgError($event)">
                                                    </div>
                                                </div>

                                                <div class="st-ti ms-ti ps-40" *ngIf="v.id">
                                                    <div class="m-img" *ngIf="v.emp_sign">
                                                        <img [src]="checkUrl(v.emp_sign)" class="img-fluid" alt="">
                                                    </div>
                                                </div>

                                                <div class="st-ti ms-ti ps-40" *ngIf="v.id">
                                                    <div class="d-flex">
                                                        <div class="status-box accept me-2"
                                                            matTooltip="{{ 'BUTTON.ACCEPT' | translate }}"
                                                            [ngClass]="{ opacity: v.app == '1' }"
                                                            (click)="confirmationAlert(v, 'status', 'yes')">
                                                            <img src="assets/images/icons/tick_correct.svg"
                                                                class="img-fluid" alt="" />
                                                        </div>
                                                        <div class="status-box reject"
                                                            matTooltip="{{ 'BUTTON.REJECT' | translate }}"
                                                            [ngClass]="{ opacity: v.app == '0' }"
                                                            (click)="confirmationAlert(v, 'status', 'no')">
                                                            <img src="assets/images/icons/cancel.svg" class="img-fluid"
                                                                alt="" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="st-ti ms-ti ps-40" *ngIf="v.id">
                                                    <i class="material-icons cursor-pointer more-ic"
                                                        [matMenuTriggerFor]="menu">more_vert</i>
                                                    <mat-menu #menu="matMenu">
                                                        <button mat-menu-item color="primary"
                                                            *ngFor="let item of employeeStatus"
                                                            (click)="onChangeEmpSt(v,item.value,'')">
                                                            <!-- <mat-icon class="kt-margin-r-0">create</mat-icon> -->
                                                            <span>{{item.name}}</span>
                                                        </button>
                                                        <button mat-menu-item color="primary"
                                                            (click)="onAddComments(v)">
                                                            <!-- <mat-icon class="kt-margin-r-0">create</mat-icon> -->
                                                            <span>Add Comments</span>
                                                        </button>
                                                    </mat-menu>
                                                </div>

                                                <!-- //just for ui -->
                                                <div class="ms-ti" *ngIf="!v.id"></div>
                                                <div class="ms-ti" *ngIf="!v.id"></div>
                                                <div class="ms-ti" *ngIf="!v.id"></div>
                                                <div class="ms-ti" *ngIf="!v.id"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="it.wo_data && it.wo_data.length > 0" class="sep-div"></div>
                                <div *ngIf="i === 0 && it.wo_data?.length > 0" class="si-ac">Shift Attachments</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="mat-table__message position-relative" *ngIf="isSpinnerLoading">
                <div class="custom-loader"> </div>
            </div>
            <div class="mat-table__message" *ngIf="timeSheetArr.length == 0 && !isSpinnerLoading">
                <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
            </div>
        </div>
    </div>
</div>